import { COLOR_BLUE_700, COLOR_BRAND_MEDIUM_ORANGE, COLOR_DARK_ORANGE_700, COLOR_GRAY_1000, COLOR_GRAY_1200, COLOR_GRAY_800, COLOR_GREEN_700, COLOR_LIGHT_ORANGE_700, COLOR_SAND_1100, COLOR_WHITE, } from '../../../themes/Light/colors.values';
export function getColor(transformer) {
    return Object.freeze({
        white: transformer.color(COLOR_WHITE),
        gray800: transformer.color(COLOR_GRAY_800),
        gray1000: transformer.color(COLOR_GRAY_1000),
        gray1200: transformer.color(COLOR_GRAY_1200),
        blue700: transformer.color(COLOR_BLUE_700),
        green700: transformer.color(COLOR_GREEN_700),
        lightOrange700: transformer.color(COLOR_LIGHT_ORANGE_700),
        darkOrange700: transformer.color(COLOR_DARK_ORANGE_700),
        brand: {
            mediumOrange: transformer.color(COLOR_BRAND_MEDIUM_ORANGE),
        },
        sand1100: transformer.color(COLOR_SAND_1100),
    });
}
